import React from "react";
import { formatPrepSeconds, getItemPreparation } from "../itemPreparation";
import { useKitchenNow } from "./TimedOrderCard";
import "./preparation.css";

const toneClass = (tone) => {
  if (tone === "green") return "is-green";
  if (tone === "orange") return "is-orange";
  if (tone === "red") return "is-red";
  return "is-neutral";
};

export default function ItemPreparation({ order, item, items, completed = false, showPriority = true, showEstimate = true, inline = false }) {
  const now = useKitchenNow();
  const preparation = getItemPreparation(order, item, items, now);
  const { timing } = preparation;
  const stopped = completed || item?.taskStatus === "COMPLETED" || item?.taskStatus === "REMOVED";
  const timingLabel = timing?.label === "Overdue by" ? "Overdue" : timing?.label;
  const estimateLabel = preparation.estimateSource === "item" ? "Item estimate"
    : preparation.estimateSource === "order" ? "Order average" : "Prep estimate";

  return (
    <section className={`kds-item-preparation ${toneClass(stopped ? "neutral" : timing?.tone)}${inline ? " is-inline" : ""}`}
      aria-label={`Preparation timing for ${item?.name || "item"}`}>
      <div className="kds-prep-summary">
        {showEstimate && (
          <span className="kds-prep-estimate">
            <span>{estimateLabel}</span>
            <strong>{formatPrepSeconds(preparation.prepSeconds)}</strong>
          </span>
        )}
        <span className="kds-prep-countdown">
          <span>{timingLabel || "Timing needed"}</span>
          <strong>{timing?.display || "—"}</strong>
        </span>
        {showPriority && preparation.priorityLabel && (
          <span className={`kds-prep-priority kds-priority-${preparation.priorityLabel.toLowerCase().replaceAll(" ", "-")}`}>
            {preparation.priorityLabel}
          </span>
        )}
      </div>
    </section>
  );
}

export function ServingGroupHeading({ order, item, items = [], index = 0 }) {
  const now = useKitchenNow();
  const preparation = getItemPreparation(order, item, items, now);
  if (preparation.priorityRank == null || !preparation.servingGroupLabel) return null;

  const previousItem = index > 0 ? items[index - 1] : null;
  const previousRank = previousItem
    ? getItemPreparation(order, previousItem, items, now).priorityRank
    : null;
  if (previousRank === preparation.priorityRank) return null;

  return (
    <div className="kds-serving-group-heading" aria-label={preparation.servingGroupLabel}>
      <span>{preparation.servingGroupLabel}</span>
      {preparation.serveTogether && <span className="kds-serving-together">Serve together</span>}
    </div>
  );
}
